(ns quuppa.ui.form
  (:require [reagent.core :as r]
            ["react-bootstrap/Form" :default Form]
            ["react-bootstrap/Button" :default Button]
            ["react-bootstrap/Row" :default Row]
            ["react-bootstrap/Col" :default Col]
            ["react-bootstrap/InputGroup" :default InputGroup]))


(def form (r/adapt-react-class Form))
(def form-label (r/adapt-react-class (.-Label Form)))
(def form-control (r/adapt-react-class (.-Control Form)))
(def form-control-feedback (r/adapt-react-class (.-Feedback (.-Control Form))))
(def input-group-text (r/adapt-react-class (.-Text InputGroup)))
(def form-group (r/adapt-react-class (.-Group Form)))
(def form-check (r/adapt-react-class (.-Check Form)))
(def form-select (r/adapt-react-class (.-Select Form)))
(def form-range (r/adapt-react-class (.-Range Form)))

(defn form-example []
  (let [validated? (r/atom false)
        form-data (r/atom {:first-name "Mark"
                           :last-name  "Otto"
                           :username   ""
                           :city       ""
                           :state      ""
                           :zip        ""
                           :agreed     false})]

    (fn []
      [form {:noValidate true
             :validated  @validated?
             :onSubmit   (fn [e]
                           (.preventDefault e)
                           (let [form (.-currentTarget e)]
                             (when (not (.checkValidity form))
                               (.stopPropagation e))
                             (reset! validated? true)))}

       ;; First Row
       [:> Row {:className "mb-3"}
        ;; First Name
        [:> Col {:md 4}
         [form-label "First name"]
         [form-control {:required    true
                        :type        "text"
                        :placeholder "First name"
                        :value       (:first-name @form-data)
                        :onChange    #(swap! form-data assoc :first-name (.. % -target -value))}]
         [form-control-feedback "Looks good!"]]

        ;; Last Name
        [:> Col {:md 4}
         [form-label "Last name"]
         [form-control {:required    true
                        :type        "text"
                        :placeholder "Last name"
                        :value       (:last-name @form-data)
                        :onChange    #(swap! form-data assoc :last-name (.. % -target -value))}]
         [form-control-feedback "Looks good!"]]

        ;; Username
        [:> Col {:md 4}
         [form-label "Username"]
         [:> InputGroup {:hasValidation true}
          [input-group-text "@"]
          [form-control {:required         true
                         :type             "text"
                         :placeholder      "Username"
                         :aria-describedby "inputGroupPrepend"
                         :value            (:username @form-data)
                         :onChange         #(swap! form-data assoc :username (.. % -target -value))}]]
         [form-control-feedback {:type "invalid"} "Please choose a username."]]]

       ;; City / State / Zip
       [:> Row {:className "mb-3"}
        [:> Col {:md 6}
         [form-label "City"]
         [form-control {:required    true
                        :type        "text"
                        :placeholder "City"
                        :value       (:city @form-data)
                        :onChange    #(swap! form-data assoc :city (.. % -target -value))}]
         [form-control-feedback {:type "invalid"} "Please provide a valid city."]]

        [:> Col {:md 3}
         [form-label "State"]
         [form-control {:required    true
                        :type        "text"
                        :placeholder "State"
                        :value       (:state @form-data)
                        :onChange    #(swap! form-data assoc :state (.. % -target -value))}]
         [form-control-feedback {:type "invalid"} "Please provide a valid state."]]

        [:> Col {:md 3}
         [form-label "Zip"]
         [form-control {:required    true
                        :type        "text"
                        :placeholder "Zip"
                        :value       (:zip @form-data)
                        :onChange    #(swap! form-data assoc :zip (.. % -target -value))}]
         [form-control-feedback {:type "invalid"} "Please provide a valid zip."]]]

       ;; Terms checkbox
       [form-group {:className "mb-3"}
        [form-check {:required     true
                     :label        "Agree to terms and conditions"
                     :feedback     "You must agree before submitting."
                     :feedbackType "invalid"
                     :checked      (:agreed @form-data)
                     :onChange     #(swap! form-data assoc :agreed (.. % -target -checked))}]]

       ;; Submit button
       [:> Button {:type "submit"} "Submit form"]])))
